module.exports = __webpack_public_path__ + "static/media/UtterNonsense.a4a0c1e4.png";